import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';
import NotFoundPage from '../../pages/presentation/demo-pages/helper/NotFoundPage';
import { useLocation } from 'react-router-dom';

const ConditionalNotFound = () => {
	const location = useLocation();
	if (location.pathname === '/customer_active') return null;
	return <NotFoundPage />;
};

const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page) => (
				<Route key={page.path} {...page} />
			))}
			<Route path='customer_active' element={<></>} />
			<Route path='*' element={<ConditionalNotFound />} />
		</Routes>
	);
};

export default ContentRoutes;
